import styled from "styled-components";

/**
 * Wrapper component for Triple Barrel Cash Blast promotional pages
 * Contains all common page-level styles and CSS variables
 */
const TBCBPageWrapper = styled.div`
  --topspacing: 110px;
  --gradientheight: 40px;

  background-color: var(--lightblack);
  color: var(--white);
  text-align: center;
  overflow-x: hidden;
  height: auto;
  padding-bottom: 40px;

  .title-section {
    p {
      font-size: 1.5rem;
      max-width: initial;
    }
  }

  .hero_text_container {
    display: none;
    padding: 0;
  }

  .hero_image_container {
    padding: 20px;
    img {
      max-height: 500px;
    }
  }

  .draw-dates {
    display: flex;
    flex-direction: row;
    justify-content: center;
    @media (max-width: 555px) {
      flex-direction: column;
    }
    > p {
      margin: 1rem;
      padding: 1rem;
      border: solid 2px #a56e27;
      strong {
        display: block;
        font-size: 1.5rem;
      }
    }
  }

  .hero_container.fluid {
    min-height: 440px;
    @media (min-width: 768px) and (max-width: 991px) {
      --topspacing: 40px;
      --gradientheight: 20px;
    }
    @media (max-width: 768px) {
      min-height: 150px;
    }
    @media (min-width: 768px) {
      top: var(--topspacing);
      margin-bottom: var(--topspacing);
      &:before {
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 1) 0%,
          rgba(0, 0, 0, 1) 71.43%,
          rgba(0, 0, 0, 0) 100%
        );
        content: "";
        height: calc(var(--topspacing) + var(--gradientheight));
        top: calc(-1 * var(--topspacing));
        position: relative;
      }
    }
  }

  p,
  li {
    strong {
      color: #d59947;
    }
  }

  li {
    padding-bottom: 0.75rem;
  }

  .works-container {
    background-color: var(--black);
    border-radius: 8px;
    border: 1px solid #634f32c8;
  }

  .how-it-works {
    h3 {
      text-align: left;
      margin-left: 1rem;
      border-color: #d59947;
      margin-bottom: 2rem;
    }
    li,
    p {
      text-align: left;
    }
    li {
      padding-bottom: 0;
    }
  }

  div.periods {
    p {
      font-size: 16px;
    }
    svg {
      margin: 20px 0 10px;
      color: #d59947;
      font-size: 40px;
    }
  }

  .sectional-tournament-tabs {
    justify-content: space-around;
    margin: 20px;
    width: calc(100% - 40px);
    button {
      min-height: unset;
      padding: 0.8rem;
      background: #634f32c8;
      &.active {
        background: #a56e27;
      }
      &:hover {
        background: #a56e27;
      }
    }
    @media (min-width: 768px) {
      button {
        max-width: 24%;
      }
    }
  }

  .tabContent {
    background-color: var(--black);
    h5 {
      margin: 1rem 0 0;
    }
    h4 {
      margin: 0 0 1rem;
      color: #d59947;
    }
    ul {
      padding-top: 0.5rem;
    }
    li {
      padding-bottom: 0;
      margin-bottom: 0;
      p:first-child {
        padding: unset;
        font-size: unset;
        line-height: unset;
        margin: unset;
        max-width: unset;
        display: inline;
      }
      .table-title {
        background-color: var(--mutedred);
        color: var(--white);
        display: inline-block;
        padding: 0.25rem 0.75rem;
        border-radius: 4px;
        margin-bottom: 0.5rem;
      }
    }
    table {
      margin: -0.5rem 0;
    }
  }
`;

export default TBCBPageWrapper;
